import css from './index.module.scss';
import { EFXStreamLogo } from '@/components/UI/svg/xstream';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function ABanner() {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('xstream');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        new ScrollMagic.Scene({
            triggerElement: '.containerBox',
            triggerHook: 1,
            offset: layoutH * 1 + 10,
        })
            .setClassToggle('.A_banner', 'enter')
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.containerBox',
            triggerHook: 1,
            offset: layoutH * 2,
        })
            .setClassToggle('.A_banner', 'leave')
            .addTo(controller);
    }, []);

    return (
        <div className={`A_banner ${css.A_banner}`}>
            <div className="allBox">
                <div className="videoBox">
                    <div className="innerVideoBox">
                        <EFVideo
                            sources={['/media/x-stream/h5/01_KV.webm', '/media/x-stream/h5/01_KV.mp4']}
                            className="banner_video"
                            width="100%"
                            height="100%"
                            preload="auto"
                        />
                        <div className="logoBox">
                            <EFXStreamLogo width="2.8rem" height=".8rem" />
                        </div>
                        <div className="cover"></div>
                    </div>
                    <div className="textBox">
                        <div className="innerBox">
                            <p className="title">{t('section_2_title')}</p>
                            <p className="desc">{t('section_2_desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
